<template>
  <div class="login">
    <div class="login-form">
      <recovery-password
        v-if="isResetPassword"
        @cancel="isResetPassword = false"
      />
      <template v-else>
        <div class="logo">
          <img src="../assets/images/logo-login.svg" />
          <p class="m-t-5" v-if="!isNotary">Личный кабинет клиента</p>
        </div>

        <div class="header">
          <template v-if="isRegisterView">
            <p class="is-subtitle">{{ fio }}</p>
            <p>{{ email }}</p>
            <p class="is-subtitle" v-if="isNewUser">
              Пожалуйста завершите регистрацию
            </p>
          </template>
          <p class="is-subtitle" v-else>Пожалуйста, авторизуйтесь</p>
        </div>

        <v-field
          v-if="!isRegisterView"
          v-model.trim="username"
          is-full-width
          :placeholder="isNotary ? 'Логин' : 'Эл. почта'"
          :is-error="!checkErrorIsFixed('username')"
          :error-text="errors.messages.username"
        />
        <v-field
          v-model.trim="password"
          type="password"
          is-full-width
          placeholder="Пароль"
          :help-text="
            isRegisterView && isNewUser
              ? 'Пароль должен состоять из восьми или более символов'
              : ''
          "
          :is-error="!checkErrorIsFixed('password')"
          :error-text="errors.messages.password"
        />
        <v-field
          v-if="isRegisterView && isNewUser"
          v-model.trim="repeatPassword"
          type="password"
          :is-error="!repeatPasswordIsValid"
          is-full-width
          placeholder="Подтверждение пароля"
        />
        <span
          v-if="errors.messages.non_field_errors"
          class="message message--error"
          v-text="errors.messages.non_field_errors"
        />

        <v-button
          :text="buttonView.text"
          :disabled="!formIsValid()"
          color="blue"
          fluid
          size="md"
          @click="buttonView.event()"
        />

        <div
          v-if="error && !errors.messages.non_field_errors"
          class="error"
        >{{ error }}</div>

        <div class="login-form__links" v-if="!isNewUser">
          <span class="link" @click="isResetPassword = !isResetPassword"
            >Забыли пароль?</span
          >
          <!-- нотариусы ходять через fciit
          <v-checkbox v-model="isNotary" class="m-t-15" v-if="isDev">
            Я нотариус
          </v-checkbox> -->
        </div>
      </template>
      <!--            <v-checkbox v-model="keepUser" class="m-t-15">-->
      <!--              Оставаться в системе-->
      <!--            </v-checkbox>-->
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { validateField } from "@/utilities";
import VField from "./VField";
import VButton from "./VButton";
import VCheckbox from "./VCheckbox";
import RecoveryPassword from "./RecoveryPassword";
import passwordValidationMixin from "../mixins/passwordValidationMixin";


export default {
  name: "LoginForm",


  components: {
    VField,
    VButton,
    VCheckbox,
    RecoveryPassword
  },


  mixins: [
    passwordValidationMixin,
  ],


  props: {
    fio: String,
    email: {
      type: String,
      default: ""
    },
    code: String,
    onlyPassword: {
      type: Boolean,
      default: false
    },
    isNewUser: {
      type: Boolean,
      default: false
    },
    showOnlyPassword: {
      type: Boolean,
      default: false
    }
  },


  data() {
    return {
      username: this.email,
      password: "",
      repeatPassword: "",
      keepUser: true,
      isNotary: document.location.hostname === process.env.VUE_APP_NOTARY_HOST,
      isResetPassword: false,

      error: '',
    };
  },


  computed: {
    ...mapGetters({
      errors: "authorization/getErrors"
    }),

    isDev() {
      return (
        process.env.NODE_ENV === "development" ||
        document.location.hostname === process.env.VUE_APP_TEST_HOST
      );
    },

    // passwordIsValid() {
    //   return validateField("password", this.password);
    // },
    // repeatPasswordIsValid() {
    //   return this.isRegisterView && this.isNewUser
    //     ? this.password === this.repeatPassword
    //     : true;
    // },

    isRegisterView() {
      return !!this.fio && !!this.email;
    },

    buttonView() {
      let event = {
        text: "Войти",
        event: this.login
      };

      if (this.isRegisterView && this.isNewUser) {
        event = {
            text: "Зарегистрироваться",
            event: this.register
          };
      }

      return event;
    },
  },


  methods: {
    async login() {
      this.error = '';

      const res = await this.$store.dispatch("authorization/login", {
        username: this.username,
        password: this.password,
        is_notary: this.isNotary
      });

      if (res) {
        this.$emit("login");
      }
      else {
        this.error = 'Ошибка: не удалось войти';
      }
    },

    async register() {
      this.error = '';

      const res = await this.$store.dispatch("authorization/registerFromAppointment", {
        user: {
          username: this.email,
          password: this.password
        },
        code: this.code
      });

      if (res) {
        this.$emit("register");
      }
      else {
        this.error = 'Ошибка: не удалось зарегистрироваться';
      }
    },

    checkErrorIsFixed(name) {
      return this.errors.checkErrorIsFixed(name, !!this[name]); //validateField(name, this[name])
    },

    formIsValid() {
      let checkRepeatPassword = true;
      if (this.isRegisterView && this.isNewUser) {
        checkRepeatPassword = this.repeatPasswordIsValid;
      }

      return (
        !!this.username &&
        this.passwordIsValid === true &&
        checkRepeatPassword === true
      );
    },
  },  // end: methods
};
</script>

<style lang="scss">
.login {
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  &-form {
    width: 500px;
    padding: 80px;
    box-sizing: border-box;
    background: white;
    margin: auto;

    &__links {
      margin-top: 20px;
    }

    .error {
      margin: 8px 0px;
      color: red;
    }

    .logo {
      margin-bottom: 20px;
      text-align: center;
    }

    .header {
      text-align: center;
      margin-bottom: 20px;

      .is-title {
        margin-bottom: 20px;
      }

      p {
        line-height: 1.5em;
      }
    }
  }
}
</style>
